import {
  Card,
  Grid,
  TextField,
  MenuItem,
  Select,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Typography,
  RadioGroup,
  Radio,
  FormLabel,
} from "@mui/material";
import WDBox from "../../../../MaterialComponents/WDBox";
import WDButton from "../../../../MaterialComponents/WDButton";
import WDTypography from "../../../../MaterialComponents/WDTypography";

import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import AppService from "../../../../Configurations/Appservice";
import { useState, useEffect } from "react";
import { CUSTOMER_ORG_TYPE, CUSTOMER_USER_TYPE } from "../../../../Configurations/AppConfig";
import { useDispatch } from "react-redux";
import {
  dismissLoader,
  showLoader,
  showSuccessMessage,
  updateScreenTitle,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import uuid from "react-uuid";
import SubTitle from "../../../../Components/SubTitle";

const initialValues = {
  name: "",
  phone: "",
  email: "",
  userName: "",
  password: "",
  admin: false,
  organisationId: "",
  who: "USER",
};

const validationSchema = object({
  name: string().required("Name is Mandatory"),
  phone: string().required("Phone Number is Mandatory"),
  email: string().email().required("Email is Mandatory"),
  userName: string().required("User Name is Mandatory"),
  password: string().required("Password is Mandatory"),
  organisationId: string().required("Service is Mandatory"),
  who: string().required("Give user type is Mandatory"),
});

const NewCustomerOrganisationUser = () => {
  const [organisations, setOrganisations] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const params = {
      type: CUSTOMER_ORG_TYPE,
    };
    AppService.get("v1/organisation/keyValues", { params })
      .then((response) => {
        setOrganisations(response);
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    dispatch(updateScreenTitle("New Customer Organisation User"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  const _submitHandler = (values, { resetForm }) => {
    dispatch(showLoader());
    // Build payload explicitly to avoid mutating Formik values object
    const who = String(values.who || '').toUpperCase();
    const payload = {
      ...values,
      userType: CUSTOMER_USER_TYPE,
      admin: who === 'ADMIN',
    };
    // Debug: verify what we are sending
    try { console.debug('NewUser payload', payload); } catch {}
    AppService.post("v1/user", payload)
      .then((response) => {
        resetForm();
        dispatch(showSuccessMessage("User Created Successfully"));
      })
      .catch((error) => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  };

  return (
    <WDBox>
      <Card sx={{ padding: 3 }}>
        <Formik
          initialValues={initialValues}
          onSubmit={_submitHandler}
          validationSchema={validationSchema}
        >
          {({ errors, isValid, touched, dirty, values, setFieldValue }) => (
            <Form>
              <WDBox>
                <SubTitle fontSize={14}>Create User</SubTitle>
              </WDBox>
              <WDBox my={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="name"
                        label="Name"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.name) && Boolean(touched.name)}
                        helperText={Boolean(touched.name) && errors.name}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="phone"
                        label="Phone Number"
                        fullWidth
                        type="tel"
                        as={TextField}
                        error={Boolean(errors.phoneNumber) && Boolean(touched.phoneNumber)}
                        helperText={Boolean(touched.phoneNumber) && errors.phoneNumber}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="email"
                        type="email"
                        label="Email"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.email) && Boolean(touched.email)}
                        helperText={Boolean(touched.email) && errors.email}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="userName"
                        label="User Name"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.userName) && Boolean(touched.userName)}
                        helperText={Boolean(touched.userName) && errors.userName}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="password"
                        label="Password"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.password) && Boolean(touched.password)}
                        helperText={Boolean(touched.password) && errors.password}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <FormControl fullWidth>
                        <InputLabel id="service-label">Customer Orgnisation</InputLabel>
                        <Field
                          name="organisationId"
                          label="Customer Orgnisation"
                          fullWidth
                          as={Select}
                          error={Boolean(errors.organisationId) && Boolean(touched.organisationId)}
                        >
                          {organisations.map((item) => (
                            <MenuItem key={uuid()} value={item.id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Field>
                      </FormControl>
                    </WDBox>
                  </Grid>
                  {/* <Grid item xs={12} md={3}>
                    <WDBox display="flex" height="100%" alignItems="center">
                      <Typography fontSize={14}>isAdmin &nbsp;</Typography>
                      <Field
                        type="checkbox"
                        name="admin"
                        as={FormControlLabel}
                        control={<Checkbox />}
                      />
                    </WDBox>
                  </Grid> */}
                  <Grid item xs={12} md={6}>
                    <FormControl>
                      {/* <FormLabel>User Type</FormLabel> */}
                      <RadioGroup
                        row
                        name="who"
                        value={values.who}
                        onChange={(e) => setFieldValue('who', e.target.value)}
                      >
                        <FormControlLabel value="USER" control={<Radio />} label="User" />
                        <FormControlLabel value="ADMIN" control={<Radio />} label="Admin" />
                        <FormControlLabel value="PRO" control={<Radio />} label="PRO" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </WDBox>
              <WDBox display="flex" justifyContent="flex-end" pt={3}>
                <WDButton variant="gradient" disabled={!dirty || !isValid} type="submit">
                  Submit
                </WDButton>
              </WDBox>
            </Form>
          )}
        </Formik>
      </Card>
    </WDBox>
  );
};

export default NewCustomerOrganisationUser;
